import { render, staticRenderFns } from "./AssignDeassignedModal.vue?vue&type=template&id=f822aa96"
import script from "./AssignDeassignedModal.vue?vue&type=script&lang=js"
export * from "./AssignDeassignedModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports